export enum ReportErrorType {
  ApplicationError = 'Application Error',
  ConfigurationError = 'Configuration Error',
  CustomError = 'Custom Error',
  NbnServiceabilityFailed = 'Nbn Serviceability Failed',
  SPCAccountsFailed = 'SPC Service Retrieval Failed '
}
